import styled from 'styled-components';
import { toRem } from '../utils/pixelUtils';
import { Typography } from '@interstate/components/Typography';
import { BreakPoint } from '@makemydeal/dr-activities-common';
export const ContractFailureReasons = styled.ul`
    margin-top: ${toRem(16)};
`;

export const ContractingFailureTitle = styled(Typography)`
    margin-bottom: ${toRem(5)} !important;
`;

export const ContractFailureAlertContainer = styled.div`
    margin-bottom: ${toRem(16)};

    a {
        color: #005ba8 !important; // override MUI theme
    }
`;

export const ContractAlertContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media (max-width: ${BreakPoint.PHONE}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const ContractAlertTextSection = styled.div`
    flex: 1;
`;

export const ContractAlertButtonSection = styled.div`
    flex-shrink: 0;
    align-content: center;

    @media (max-width: ${BreakPoint.PHONE}) {
        align-self: flex-end;
    }
`;
